import * as React from "react";
import { AppBar, IconButton, Box, Toolbar } from "@mui/material";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";

// import { makeStyles } from "@mui/styles";
// import NavMenu from "./NavMenu";
// import { MenuItem, Typography } from "@mui/material";

// const useStyles = makeStyles({
//   logo: {
//     height: "75px",
//   },
// });

export default function ButtonAppBar() {
  // const classes = useStyles();
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "center",
            backgroundColor: "#769525",
          }}
        >
          <IconButton
            href="https://twitter.com/plantbuilt"
            target="_blank"
            rel="noopener noreferrer"
          >
            <TwitterIcon fontSize="large" style={{ color: "black" }} />
          </IconButton>
          <IconButton
            href="https://www.facebook.com/VeganOlympia"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FacebookIcon fontSize="large" style={{ color: "black" }} />
          </IconButton>
          <IconButton
            href="https://www.youtube.com/user/plantbuilt"
            target="_blank"
            rel="noopener noreferrer"
          >
            <YouTubeIcon fontSize="large" style={{ color: "black" }} />
          </IconButton>
          <IconButton
            href="https://www.instagram.com/plantbuilt/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <InstagramIcon fontSize="large" style={{ color: "black" }} />
          </IconButton>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
